























































import { has } from "lodash";
import { Vue, Watch } from "vue-property-decorator";
import Component from "vue-class-component";
import { namespace } from "vuex-class";
import { SvgIcon, Message } from "@brankas/web-ui";
import { Route } from "vue-router";
import { GoogleLogin } from "@/components";
import { GoogleUser, UserProfile } from "@/types";

const authModule = namespace("auth");

@Component({
  components: {
    GoogleLogin,
    SvgIcon,
    Message,
  },
})
export default class Login extends Vue {
  @authModule.Action("updateAuthInfo") updateAuthInfo!: (
    googleUser: GoogleUser
  ) => void;

  @authModule.State("user") user!: UserProfile;

  redirectUrl: string | null = null;
  showErrorMessage = false;

  @Watch("$route", { immediate: true })
  watchRoute(route: Route) {
    const { query } = route;
    if (has(query, "redirect")) {
      this.showErrorMessage = true;
      this.redirectUrl = query["redirect"] as string;
    }
  }

  // to detect if login success
  @Watch("user", { immediate: true, deep: true })
  watchUser(user: UserProfile) {
    if (!user?.email) return;
    this.$router.push(this.redirectUrl || "/");
  }
}
